// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X30ZP","delete":"styles_delete__1o8X7","update":"styles_update__2KB_W","add":"styles_add__2nDhp"};